export * from './main';
export * from './result-quiz-card';
